module.exports = __webpack_public_path__ + "static/kerakoll.c5e35429.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/logos/kerakoll.png
// module id = 364
// module chunks = 35783957827783